<template>
    <div class="modal-auth">
        <transition name="fade">
            <div class="modal-auth__loader"
                v-if="isLoading"
                >
                <div class="modal-auth__loader-container">
                    <ui-loader />
                </div>
            </div>
        </transition>
        <div class="modal-auth__title">
            Войти или создать аккаунт
        </div>
        <div class="modal-auth__form">
            <ui-form
                v-bind:model="fields"
                v-bind:validation="$v"
                v-bind:submit-handler="submitHandler"
                v-on:update="updateFormData"
            />
            <div class="modal-auth__form-checkbox">
                <ui-checkbox-consent
                    v-model="consent"
                    v-bind:is-error="consentError"
                />
            </div>
            <div class="modal-auth__form-error"
                v-if="error"
                v-text="error"
            />
<!--            <div class="modal-auth__form-button">
                <ui-button
                    v-on:click="submitHandler(true)"
                    is-uppercase
                >
                    <icon name="telegram" width="38" height="38"/>
                    Войти через telegram
                </ui-button>
            </div>-->
            <div class="modal-auth__form-button">
                <ui-button
                    v-on:click="submitHandler(false)"
                    v-text="'Получить код'"
                    is-uppercase
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import forms from '~/forms';
import utils from '~/utils';

export default {
    name: 'modal-auth',
    props: {
        phone: {
            type: String,
            default: null,
        },
        onSuccess: {
            type: Function,
            default: null,
        },
    },
    data: () => ({
        fields: {
            phone: { ...forms.fields.phone, value: '+7', isAutofocus: true },
        },
        code: null,
        consent: false,
        consentError: false,
    }),
    validations: {
        fields: {
            phone: { ...forms.validations.phone },
        },
    },
    computed: {
        ...mapState('user', [
            'authResult',
            'authIsLoading',
            'authError',
        ]),
        isLoading() {
            return this.authIsLoading;
        },
        error() {
            return utils.network.parseError(this.authError, true);
        },
    },
    methods: {
        updateFormData(newData) {
            this.fields = newData;
        },
        checkConsent() {
            this.consentError = !this.consent;
        },
        submitHandler(telegram = false) {
            if (this.$v.$invalid) {
                this.$v.$touch();
                this.checkConsent();
                return;
            }
            if (!this.consent) {
                this.checkConsent();
                return;
            }
            if (telegram) {
                this.showTelegramModal();
                return;
            }
            if (this.code) {
                this.auth();
            } else {
                this.showSmsModal();
            }
        },
        auth() {
            this.$store.dispatch('user/auth', {
                phone: this.fields.phone.value,
                code: this.code,
            });
        },
        showSmsModal() {
            this.$store.commit('modals/push', {
                name: 'sms-verification',
                props: {
                    phone: this.fields.phone.value,
                    callback: this.setCode,
                },
            });
        },
        setCode(code) {
            this.code = code;
            this.submitHandler();
        },
        showTelegramModal() {
            this.$store.commit('modals/push', {
                name: 'auth-telegram',
                props: {
                    phone: this.fields.phone.value,
                    onSuccess: () => {
                        if (this.onSuccess) {
                            this.onSuccess();
                        }
                        this.close();
                    },
                    onShowSmsModal: () => {
                        this.showSmsModal();
                    },
                },
            });
        },
        close() {
            this.$store.commit('modals/pop');
        },
    },
    beforeMount() {
        if (this.phone) {
            this.fields.phone.value = this.phone;
        }
    },
    watch: {
        authIsLoading(newVal) {
            if (!newVal && this.authResult) {
                if (this.onSuccess) {
                    this.onSuccess();
                }
                this.close();
            }
        },
        consent(newVal) {
            if (newVal) {
                this.consentError = false;
            }
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-auth {
    .mixin-modal();

    position: relative;

    max-width: 340px;
    padding: 40px;

    box-shadow: 0 0 60px 0 @color-accent-cold;
    &__loader {
        .transition-fade();

        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        background: @color-gray-lightest;
        &-container {
            width: 50px;
        }
    }
    &__title {
        margin-bottom: 36px;

        text-transform: uppercase;
    }
    &__form {
        width: 100%;
        max-width: 260px;
        &-checkbox {
            margin-top: 12px;
        }
        &-error {
            margin-bottom: 36px;

            color: @color-accent-warm;
        }
        &-button {
            height: 48px;
            margin-top: 20px;
            /* &:last-child {
                margin-top: 8px;
            } */
        }
    }
    &__disclaimer {
        margin-top: 16px;
        &-trigger {
            .mixin-link-decoration();

            cursor: pointer;
        }
    }
    @media @media-md-down {
        &__title {
            margin-bottom: 9px;
        }
    }
}
</style>
